<template lang="pug">
GenericCard(size='40')
  template(v-if='isSubmitted === false')
    .location.d-flex.flex-column.px-4.py-4
      .text-title กำหนดตำแหน่งร้าน
      template(v-if="isGeoLocationSupported")
        button.btn.btn-outline-primary.mt-3(@click="requestCurrentPosition") เลือกตำแหน่งปัจจุบัน
      //- InputWithIconSlot.mt-4( placeholder='ค้นหาด้วยชื่อ' width='100%' )
        i.fa.fa-search

      .map.mt-3(style="height: 250px;")
        LMap(
          :zoom="15"
          :center="$latLng(initialZoom.lat, initialZoom.lng)"
        )
          LTileLayer(
            url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          )
          LMarker(
            :lat-lng="$latLng(position.lat, position.lng)"
            :draggable="true"
            @update:lat-lng="updatePosition")
        //- img.w-100.ml-1(src='@/assets/_mock/map.svg')

      button.btn.btn-upa-secondary.mx-auto.my-2(@click='submitLocation' :disabled="isSubmitting")
        template(v-if="isSubmitting"): .spinner-border
        template(v-else) บันทึกตำแหน่ง

  template(v-else)
    .submitted.d-flex.flex-column
      .px-4.py-4
        .text-title บันทึกข้อมูลการเข้าเยี่ยม
      hr.m-0
      .response-message
        img(src='@/assets/icons/success.svg')
        .text-large.mt-3
          | คุณบันทึกตำแหน่งร้านสำเร็จแล้ว

</template>

<script>
export default {
  props: {
    customer: {
      default: () => ({}),
    },
  },
  computed: {
    isGeoLocationSupported() {
      return navigator.geolocation;
    },
  },
  data: () => ({
    hasChanged: false,
    isSubmitting: false,
    isSubmitted: false,
    initialZoom: {
      lat: 13.7143547,
      lng: 100.5133467,
    },
    position: {
      lat: 13.7143547,
      lng: 100.5133467,
    },
  }),
  // TODO: obtain location from prop:customer
  methods: {
    updatePosition(latLng) {
      this.position = {
        lat: latLng.lat,
        lng: latLng.lng,
      };
      this.hasChanged = true;
    },
    async requestCurrentPosition() {
      const perm = await navigator.permissions.query({ name: 'geolocation' });
      if (perm.state !== 'denied') {
        navigator.geolocation.getCurrentPosition((position) => {
          this.position = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          this.initialZoom = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
        });
      } else {
        alert('คุณจำเป็นต้องอนุญาตการเข้าถึงตำแหน่งเพื่อรับตำแหน่งปัจจุบัน'); // eslint-disable
      }
    },
    async submitLocation() {
      this.isSubmitting = true;
      const res = await this.$api.customer.history.checkinByLatLng(
        this.customer.id, this.position.lat, this.position.lng,
      );
      console.log(res);
      this.isSubmitted = true;
    },
  },
};
</script>

<style lang="scss">
// .location {}
.response-message {
  min-height: 360px;
  background: #FAFAFA;

  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;
}
</style>
